<template>
    <div class="error-page">
        <div class="error-page-wrapper">
            <div>Please retry again</div>
            <div>There is some error occurred from</div>
            <div>Line Server</div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'


export default {
    name: "errorpage",
    components: {
    },
    data: function() {
        return {

        };
    },
    created: function() {
       

    },
    methods: {
        
    },
};
</script>
<style lang="scss" scoped>
    .error-page {
        min-height: 100vh;
        color: black;
        display: flex;

        .error-page-wrapper {
            margin: auto;
            text-align: center;
            font-size: 1rem;
        }
    }
</style>